<template>
  <van-popup v-model="onShow" position="bottom" class="pay-popup">
    <van-row align="center" class="pay-header">
      <van-search
        v-model="value"
        @input="onSearch"
        @clear="onReset"
        shape="round"
        :placeholder="$t.meta.search"
      />
    </van-row>

    <div class="pay-content" v-if="items">
      <van-cell-group v-for="(item, index) in items" :key="index" @click="onClick(item)">
        <van-cell
          :title="item.text"
          :value="item.rightText"
          :class="item.image ? 'isImg' : ''"
        >
          <template #right-icon>
            <van-image
              class="nationImg"
              v-if="item.image"
              :src="imgUrlFilter(item.image)"
            ></van-image>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </van-popup>
</template>

<script>
import Vue from "vue";
import { Popup, Row, CellGroup, Cell, Search, Image } from "vant";
Vue.use(Popup).use(Row).use(CellGroup).use(Cell).use(Search).use(Image);

export default {
  name: "OptionList",
  props: ["options", "event"],
  data() {
    return {
      value: "",
      items: [],
      onShow: false,
    };
  },
  watch: {
    options() {
      this.items = this.options;
    },
  },
  mounted() {
    this.$bus.$off(this.event).$on(this.event, (isShow) => {
      this.onShow = isShow;
    });
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onSearch() {
      var items = [];
      for (const item of this.items) {
        var text = item.text;
        if (text.includes(this.value)) {
          items.push(item);
        }
      }
      if (items && items.length > 0) {
        if (this.value) {
          this.items = items;
        } else {
          this.items = this.options;
        }
      }
    },
    onReset() {
      this.items = this.options;
    },
    onClick(item) {
      this.$emit("onSelect", item);
      this.onShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.pay-popup {
  height: 70%;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  .pay-header {
    width: auto;
    padding: 2%;
    .pay-title {
      width: 100%;
      text-align: center;
      font-weight: bold;
    }
    .pay-subtitle {
      width: 100%;
      text-align: center;
      font-weight: bold;
      font-size: 2rem;
      margin-top: 0.5rem;
      .boxUnit {
        font-size: 1.5rem;
        margin-left: 4px;
        margin-right: 4px;
      }
    }
  }
  .pay-content {
    .isImg {
      ::v-deep .van-cell__title {
        span {
          display: block;
          margin-top: 3px;
        }
      }
    }
    .nationImg {
      width: 30px;
      height: 30px;
      ::v-deep .van-image__img {
        object-fit: cover;
      }
    }
  }
}
</style>
